var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortArrowDown = function SvgShortArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.914 15.496c.115-.114.115-.32 0-.456l-.937-.91c-.115-.136-.32-.136-.458 0l-3.978 3.981c-.206.205-.572.046-.572-.25V.319a.31.31 0 0 0-.32-.319h-1.304a.31.31 0 0 0-.32.319V17.86c0 .296-.343.455-.549.25l-4.001-3.98c-.114-.114-.32-.114-.457 0l-.915.91a.33.33 0 0 0 0 .477l5.03 5.004c.32.296.732.478 1.167.478h1.395a1.73 1.73 0 0 0 1.166-.478z"
  })));
};
export default SvgShortArrowDown;